import { useRef, useState } from 'react';
import { useUploadDocument } from '../../hooks/useDocuments.js';
import { useError } from '../shared/ErrorBanner.jsx';

export const DOC_KINDS = ['cdl','osha10','osha30','i9','w4','drug_test','medical','license','other'];
export const DOC_KIND_LABELS = {
  cdl: 'CDL', osha10: 'OSHA 10', osha30: 'OSHA 30',
  i9: 'I-9', w4: 'W-4', drug_test: 'Drug test',
  medical: 'Medical', license: 'License', other: 'Other',
};

export default function DocUploadForm({ targetUser, isAdmin, onDone }) {
  const fileRef = useRef(null);
  const [kind, setKind] = useState('cdl');
  const [label, setLabel] = useState('');
  const [expires, setExpires] = useState('');
  const upload = useUploadDocument();
  const { show } = useError();

  const submit = async (e) => {
    e.preventDefault();
    const file = fileRef.current?.files?.[0];
    if (!file) return show('Choose a file');
    try {
      const form = new FormData();
      form.append('file', file);
      form.append('kind', kind);
      if (label) form.append('label', label);
      if (expires) form.append('expires_at', expires);
      if (isAdmin && targetUser && targetUser !== 'all') form.append('user_id', targetUser);
      await upload.mutateAsync(form);
      onDone();
    } catch (err) {
      show(err.message);
    }
  };

  return (
    <form onSubmit={submit} style={{ marginBottom: 20, padding: 16, background: 'var(--surface-container)' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 8 }}>
        <div className="field">
          <label className="field-label">Kind</label>
          <select className="field-select" value={kind} onChange={e => setKind(e.target.value)}>
            {DOC_KINDS.map(k => <option key={k} value={k}>{DOC_KIND_LABELS[k]}</option>)}
          </select>
        </div>
        <div className="field">
          <label className="field-label">Label (optional)</label>
          <input className="field-input" value={label} onChange={e => setLabel(e.target.value)} />
        </div>
      </div>
      <div className="field">
        <label className="field-label">Expires (yyyy-mm-dd)</label>
        <input className="field-input" type="date" value={expires} onChange={e => setExpires(e.target.value)} />
      </div>
      <div className="field">
        <label className="field-label">File (PDF / image, max 25 MB)</label>
        <input ref={fileRef} type="file" accept="application/pdf,image/*" required />
      </div>
      <button className="btn-sm primary" type="submit" disabled={upload.isPending}>
        {upload.isPending ? 'Uploading…' : 'Upload'}
      </button>
    </form>
  );
}
